import { OrderItem } from '@components';
import { Container, Icon, Input, Typography } from '@design-system';
import { OrderStatuses } from '@services';
import React from 'react';
import { HiMiniMagnifyingGlass } from 'react-icons/hi2';
import './EpiFavoriteOrdersPage.scss';
import { EpiFavoriteOrdersSkeleton } from './EpiFavoriteOrdersSkeleton';
import { useEpiFavoriteOrdersPageVM } from './useEpiFavoriteOrdersPageVM';

export const EpiFavoriteOrdersPage: React.FC = () => {
    const { orders, isLoading, searchTerm, setSearchTerm } = useEpiFavoriteOrdersPageVM();

    return (
        <div className="epi-favorite-orders-page">
            <Container className="search-container" padding="medium large">
                <Input
                    placeholder=""
                    value={searchTerm}
                    onValueChange={setSearchTerm}
                    className="search-input"
                    icon={<Icon icon={<HiMiniMagnifyingGlass />} size={25} color="grey" />}
                    iconPosition="left"
                />
            </Container>

            {isLoading ? (
                <EpiFavoriteOrdersSkeleton />
            ) : (
                <Container padding="none" radius="none" className="epi-favorite-orders-page-orders">
                    <div className="epi-favorite-orders-page-orders-list">
                        {orders.length === 0 ? (
                            <Typography intrinsic="p" className="pt-large-spacing">
                                Aucun panier favori EPI trouvé
                            </Typography>
                        ) : (
                            <>
                                {orders.map((order) => (
                                    <OrderItem
                                        key={order.id}
                                        id={order.id}
                                        title={order.title}
                                        products={[]}
                                        customProducts={{ products: order.products }}
                                        isFavorite
                                        type="epi"
                                        id_operator={0}
                                        id_worksite={0}
                                        date_order={new Date().toISOString()}
                                        comment={''}
                                        status={OrderStatuses.FAVORITED}
                                        isPast={true}
                                    />
                                ))}
                            </>
                        )}
                    </div>
                </Container>
            )}
        </div>
    );
};
